<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="row">
        <div class="text-left">
          <h4>Vehiculo - Moto</h4>
        </div>
        <!-- MARCA -->
        <div v-if="isFieldVisible('motorcycle_mark')" class="col-md-2 mt-3">
          <div class="form-group bordered">
            <label for="motorcycle_mark" class="form-label text-left">{{ getFieldDescription('motorcycle_mark') }}</label>
            <input
              type="text"
              class="form-control"
              required="required"
              name="motorcycle_mark"
              v-model="formData.motorcycle_mark"
              maxlength="255"
              @input="() => emitFieldChanged('motorcycle_mark')"
            />
          </div>
        </div>
        <!-- MODELO -->
        <div v-if="isFieldVisible('motorcycle_model')" class="col-md-2 mt-3">
          <div class="form-group bordered">
            <label for="motorcycle_model" class="form-label text-left">{{ getFieldDescription('motorcycle_model') }}</label>
            <input
              type="text"
              class="form-control"
              required="required"
              name="motorcycle_model"
              v-model="formData.motorcycle_model"
              maxlength="255"
              @input="() => emitFieldChanged('motorcycle_model')"
            />
          </div>
        </div>
        <!-- AÑO -->
        <div v-if="isFieldVisible('motorcycle_year')" class="col-md-2 mt-3">
          <div class="form-group bordered">
            <label for="motorcycle_year" class="form-label text-left">{{ getFieldDescription('motorcycle_year') }}</label>
            <SelectYears
              :data="formData.motorcycle_year"
              v-bind:selectedYear="selectedYears" 
              v-on:update:selectedYear="selectedYears = $event"
              @change="emitFieldChanged('motorcycle_year')"
              required="required"
              maxlength="255"
            >
            </SelectYears>
          </div>
        </div>
        <!-- PATENTE -->
        <div v-if="isFieldVisible('motorcycle_patent')" class="col-md-2 mt-3">
          <div class="form-group bordered">
            <label for="motorcycle_patent" class="form-label text-left">{{ getFieldDescription('motorcycle_patent') }}</label>
            <input
              type="text"
              class="form-control"
              required="required"
              name="motorcycle_patent"
              v-model="formData.motorcycle_patent"
              maxlength="255"
              @input="() => emitFieldChanged('motorcycle_patent')"
            />
          </div>
        </div>
        <!-- VIN -->
        <div v-if="isFieldVisible('motorcycle_vin')" class="col-md-4 mt-3">
          <div class="form-group bordered">
            <label for="tel" class="form-label text-left">{{ getFieldDescription('motorcycle_vin') }}</label>
            <input
              type="tel"
              class="form-control"
              required="required"
              name="motorcycle_vin"
              v-model="formData.motorcycle_vin"
              maxlength="255"
              @input="() => emitFieldChanged('motorcycle_vin')"
            />
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue';
import SelectYears from './selectDatos/SelectYears'

export default {
  name: 'FormVehicleMoto',
  props: {
    data: Object,
  },
  components: {
    SelectYears,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const selectedYears = ref("");

    const formData = ref({
      motorcycle_mark: null,
      motorcycle_model: null,
      motorcycle_year: null,
      motorcycle_patent: null,
      motorcycle_vin: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.motorcycle_mark ||
            dataCompany.value.motorcycle_model ||
            dataCompany.value.motorcycle_year ||
            dataCompany.value.motorcycle_patent ||
            dataCompany.value.motorcycle_vin)
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      formData.value.motorcycle_year = selectedYears.value || null;
      emit('formDataChanged',  formData.value);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      selectedYears,
      formData,
      emitFieldChanged,
    };
  },
};
</script>
 
